// Utility to detect if the user is on a mobile device
export const isMobileDevice = () => {
  // Check screen width (less than 768px is considered mobile/small tablet)
  const isSmallScreen = window.innerWidth < 768;
  
  // Check user agent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  
  // Return true if either condition is met
  return isSmallScreen || isMobileUserAgent;
};

// Check if device is specifically a tablet (larger than mobile but still touch)
export const isTabletDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isTabletUserAgent = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
  const isTabletScreen = window.innerWidth >= 768 && window.innerWidth <= 1024;
  
  return isTabletUserAgent || isTabletScreen;
};
